import { Swiper, Navigation, A11y } from 'swiper';
import HideOffscreenSlides from '../../components/modules/swiper-hide-offscreen';

function init() {
  document.querySelectorAll('.awards__slider.swiper').forEach((slider) => {
    const block = slider.closest('.awards');
    const prevEl = block.querySelector('.awards__button--prev');
    const nextEl = block.querySelector('.awards__button--next');

    return new Swiper(slider, {
      modules: [Navigation, A11y, HideOffscreenSlides],
      spaceBetween: 40,
      navigation: { prevEl, nextEl },
      a11y: {
        prevSlideMessage: prevEl.getAttribute('aria-label'),
        nextSlideMessage: nextEl.getAttribute('aria-label'),
      },
    });
  });
}

window.addEventListener('load', init);
